import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import pluralize from 'rebook/apps/utils/text/pluralize';

import styles from './style.scss';


function TitleTemplate(props) {
  const { title, type, count, linkUrl, linkUrlText } = props;
  const titleTypeCountText = {
    book: pluralize(count, 'книга', 'книги', 'книг'),
    audiobook: pluralize(count, 'аудиокнига', 'аудиокниги', 'аудиокниг'),
    series: pluralize(count, 'серия', 'серии', 'серий'),
    bookset: pluralize(count, 'подборка', 'подборки', 'подборок'),
  };
  const linkArrowText = linkUrlText ? linkUrlText : `${count} ${titleTypeCountText[type]}`;

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h2>{title}</h2>
        {count && (
          <div className={styles.count}>
            {count} {type && titleTypeCountText[type]}
          </div>
        )}
      </div>
      {Boolean(linkUrl) && count > 10 && (
        <div className={classNames(styles.arrow, 'link')}>
          {type && <span className={styles.arrowText}>{linkArrowText}</span>}
        </div>
      )}
    </div>
  );
}


export default function AuthorDetailListTitle(props) {
  const { linkUrl } = props;
  return (
    <React.Fragment>
      {Boolean(linkUrl)
        ? (
          <Link to={linkUrl}>
            <TitleTemplate {...props} />
          </Link>
        )
        : <TitleTemplate {...props} />
      }
    </React.Fragment>
  );
};

AuthorDetailListTitle.propTypes = {
  linkUrl: PropTypes.string,
  linkUrlText: PropTypes.string,
  title: PropTypes.string.isRequired,
  type: PropTypes.string,
  count: PropTypes.number,
};
